import { useState, useEffect } from "react";
import useValidator from "../../../hooks/useValidator";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid } from "@mui/material";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const index = ({ isOpen, onClose, onSuccess }) => {
  const [termValidator, showTermValidator] = useValidator();
  const [sessionData, setSessionData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [termForm, setTermForm] = useState({
    term: "",
    session_id: "",
    start_date: "",
    end_date: "",
    is_current: false
  });

  const getAllSession = () => {
    httprequest.get(SESSION_ENDPOINT).then((res) => {
      setSessionData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleIsCurrent = (e) => {
    const { name, checked } = e.target;
    setTermForm({ ...termForm, [name]: checked });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTermForm({ ...termForm, [name]: value });
  };

  const handleCreateTerm = () => {
    if (termValidator.allValid()) {
      setIsLoading(true);
      httprequest.post(TERM_ENDPOINT, { terms: [termForm] }).then((res) => {
        setIsLoading(false);
        const toastId = toast.success(res?.data?.message, {
          autoClose: 3000
        });

        setTimeout(() => {
          toast.dismiss(toastId);
          if (onSuccess) onSuccess();
          // window.location.reload();
        }, 3000);
        setTermForm({ ...termForm, term: "", session_id: "", start_date: "", end_date: "", is_current: false });
        onClose();
      }).catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showTermValidator(true);
    }
  };

  useEffect(() => {
    getAllSession();
  }, []);

  const { session_id, term, start_date, end_date } = termForm;

  return (
    <div>
      <Modal
        title="Create Term"
        subtitle="Create a term to an existing session."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required inputName="term" type="text" label="Term Name" placeHolder="e.g 1st Term" value={term}
                  onChange={handleChange}
                />
                {termValidator.message("Term", term, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup label="Select Session" children={
                  <select onChange={handleChange} name="session_id" value={session_id}>
                    <option value="">---Select---</option>
                    {sessionData?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>{sesh?.session}</option>
                      );
                    })}
                  </select>
                }
                />
                {termValidator.message("Session", session_id, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required inputName="start_date" inputType="date" label="Start Date" value={start_date} onChange={handleChange} />
                {termValidator.message("Start Date", start_date, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required inputName="end_date" inputType="date" label="End Date" value={end_date} onChange={handleChange} />
                {termValidator.message("Start Date", end_date, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <input type="checkbox" name="is_current" id="current_term" onChange={handleIsCurrent} />
                <label className="checkbox-label" for="current_term">Current Term</label>
              </Grid>

            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              onClick={handleCreateTerm}
              variant="primary"
              buttonName="Create New Term"
              buttonSize="full"
              color="btndefault"
              isLoading={isLoading}
            />
          </>
        }
        isopen={isOpen}
        closeModal={onClose}
      />
    </div>
  );
};

export default index;
